<span class="text-nowrap" (click)="onClickFocusArea()">
    <i *ngIf="!isFocusArea" class="far unfocused fa-lg fa-star" [title]="readonly ? 'Focus Area' : 'Set Focus Area'" [ngClass]="!readonly ? 'enabled' : ''"></i>
    <i *ngIf="isFocusArea" class="fas focused fa-lg fa-star" [title]="readonly ? 'Focus Area' : 'Remove Focus Area'"></i>
</span>